import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AttendanceSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'AttendanceSettings' */ './components/AttendanceSettings'
		)
);

export default (store) => {
	return {
		path: 'attendance-settings',
		element: <AsyncLoading component={<AttendanceSettingsLazy />} />,
	};
};
